<template>
  <b-modal
    v-model="editorShown"
    title="Place Patient in Groups"
    @hidden="onHidden"
    @ok="submitPlaceClient"
    centered
    size="md"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <template v-slot:modal-footer>
      <div class="text-right mt-1 mr-2">
        <b-button @click="$emit('onModify')" variant="secondary"
          >Cancel</b-button
        >
        <b-button class="ml-2" @click="submitPlaceClient" variant="primary"
          >Save</b-button
        >
      </div>
    </template>
    <b-form-group
      label="Date"
      :state="formErrors.date.length == 0 ? null : false"
      :invalid-feedback="formErrors.date.join(', ')"
    >
      <date-picker v-model="form.date" :errors="formErrors.date"></date-picker>
    </b-form-group>
    <b-form-group
      v-if="form.date"
      :label="
        'Select the groups for this patient on ' +
          formatDateOnly(form.date) +
          ':'
      "
      :state="formErrors.groups.length == 0 ? null : false"
      :invalid-feedback="formErrors.groups.join(', ')"
    >
      <b-form-checkbox-group v-model="form.groups" name="event-type" size="lg">
        <div
          v-for="group in groups"
          :key="group.id"
          class="bg-extra-light-gray border border-color-light-gray mb-2 p-2"
          style="font-size: 14px"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div class="d-flex align-items-center">
                <span
                  >{{ formatTimeOnly(group.startDateTime) }} -
                  {{ formatUser(group.provider) }}
                </span>
                <span class="badge badge-primary ml-2">
                  {{ group.episodesOfCare.length }} patients
                </span>
              </div>
              <div>
                {{ group.topic?.type }}
              </div>
            </div>
            <b-form-checkbox class="mb-1" :value="group.id"> </b-form-checkbox>
          </div>
        </div>
      </b-form-checkbox-group>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "../controls/DatePicker";
import { validateRequired } from "../../helpers/validation";
import { formatEndDateSql, formatStartDateSql } from "../../helpers/date";
import scheduleEventServer from "../../server/scheduleEvent";

export default {
  name: "EocViewCalendarPlaceInGroupsModal",
  components: { DatePicker },
  props: ["eocId"],
  data() {
    return {
      submit: null,
      form: {
        date: null,
        groups: []
      },
      formErrors: {
        date: [],
        groups: []
      },
      groups: []
    };
  },
  async mounted() {
    this.fetchGroups();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    onHidden() {},
    validateSubmitPlaceClient() {
      let withoutErrors = true;

      this.formErrors.date = [];
      if (!validateRequired(this.form.date)) {
        this.formErrors.date.push("This field is required");
        withoutErrors = false;
      }
      return withoutErrors;
    },
    async submitPlaceClient(modalEvent) {
      modalEvent.preventDefault();
      const result = await this.validateSubmitPlaceClient();
      if (result) {
        const scheduleEventToRemove = [];
        for (let index = 0; index < this.groups.length; index++) {
          const group = this.groups[index];
          if (
            group.episodesOfCare.filter(p => p.episodeOfCare.id == this.eocId)
              .length > 0
          ) {
            let selected = false;
            for (let index2 = 0; index2 < this.form.groups.length; index2++) {
              const selectedGroup = this.form.groups[index2];
              if (selectedGroup == group.id) selected = true;
            }
            if (!selected) scheduleEventToRemove.push(group.id);
          }
        }
        const formData = {
          scheduleEventToAdd: this.form.groups,
          scheduleEventToRemove: scheduleEventToRemove,
          episodeOfCareId: this.eocId
        };
        await scheduleEventServer.placeClientInGroups(formData);
        this.showAlertSuccess();
        this.$emit("onModify");
      } else {
        //this.$dialog.alert("You have some errors in the form");
      }
    },
    async fetchGroups() {
      const self = this;
      if (this.form.date) {
        const result = await scheduleEventServer.query({
          startDateFrom: formatStartDateSql(this.form.date),
          startDateTo: formatEndDateSql(this.form.date),
          endDateFrom: null,
          endDateTo: null,
          providerIds: [],
          episodeOfCares: [],
          creationDateFrom: null,
          creationDateTo: null,
          page: 0,
          pageSize: 1000000,
          orderBy: "creationDate",
          orderByDescending: true,
          types: ["GroupSession"]
        });
        self.groups = result;
        const newFomGroups = [];
        for (let index = 0; index < self.groups.length; index++) {
          const group = self.groups[index];
          if (group.episodesOfCare.some(x => x.episodeOfCare.id == self.eocId))
            newFomGroups.push(group.id);
        }
        self.form.groups = newFomGroups;
      } else {
        this.groups = [];
      }
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    "form.date": function() {
      this.form.groups = [];
      this.fetchGroups();
    }
  }
};
</script>
